import { Component, computed, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { ActivatedRoute, RouterLink } from '@angular/router'
import { map } from 'rxjs'
import { Lang, TRANSLATIONS } from './blank.translations'

@Component({
  selector: 'app-blank',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './blank.component.html',
  styleUrl: './blank.component.scss',
})
export class BlankComponent {
  private route = inject(ActivatedRoute)

  // Language is driven entirely by the :lang route segment (/merchant/en, /merchant/pt),
  // not a runtime toggle — each URL renders in exactly one language.
  lang = toSignal(
    this.route.paramMap.pipe(
      map((params) => (params.get('lang') === 'pt' ? 'pt' : 'en') as Lang)
    ),
    { initialValue: 'en' as Lang }
  )

  t = computed(() => TRANSLATIONS[this.lang()])
}
